import React from 'react';

import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { GENERATOR_NAMES } from 'common/components/CopyMagic/constants';
import CourseOutline from 'common/components/CopyMagic/generators/CourseOutline';
import ContentAssistant from 'common/components/CopyMagic/generators/ContentAssistant';
import HeadlineAssistant from 'common/components/CopyMagic/generators/HeadlineAssistant';
import ConversationAssistant from 'common/components/CopyMagic/generators/ConversationAssistant';

// TODO: specs needed

const GENERATOR_CONFIGS = {
  [GENERATOR_NAMES.COURSE_OUTLINE]: { component: CourseOutline },
  [GENERATOR_NAMES.CONTENT_ASSISTANT]: { component: ContentAssistant },
  [GENERATOR_NAMES.HEADLINE_ASSISTANT]: { component: HeadlineAssistant },
  [GENERATOR_NAMES.CONVERSATION_ASSISTANT]: { component: ConversationAssistant },
};

const GeneratorWrapper = () => {
  const { generatorName } = useConfigContext();
  const GeneratorComponent = GENERATOR_CONFIGS[generatorName].component;
  return <GeneratorComponent /> || null;
};

export default GeneratorWrapper;
